/**
 * Font loading configuration.
 *
 * Uses the "media=print swap" trick to make Google Fonts non-render-blocking:
 * 1. The browser fetches the stylesheet with media="print" (not render-critical)
 * 2. Once loaded, onload swaps it to media="all" — fonts apply without blocking FCP
 * 3. A <noscript> fallback in RootShell covers users with JavaScript disabled
 *
 * preconnect hints are placed before the stylesheet so DNS/TLS handshakes
 * complete before the font CSS request fires.
 */

const FONT_URL =
  "https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,300;9..144,400;9..144,500&family=Jost:wght@300;400;500&display=swap";

export const fontLinks = [

  // Non-blocking font load: media="print" tells the browser this is non-critical.
  // The onload handler switches it to media="all" once the CSS is fetched.
  {
    rel: "stylesheet" as const,
    href: FONT_URL,
    media: "print" as const,
    onload: "this.media='all'",
  },
] as const;

/** Inline noscript fallback string — paste into RootShell head for no-JS users */
export const fontNoscriptHref = FONT_URL;
